import styled, { css } from 'styled-components'
import { SharedWrapper } from 'components/shared/RadioButtons/styles'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'

interface WrapperProps {
    isChecked: boolean
    hasInfo?: boolean
    isDisabled?: boolean
}

export const Wrapper = styled(SharedWrapper)<WrapperProps>`
    @media ${respondAbove.xl} {
        padding: 22px 40px;
    }

    ${({ hasInfo }) =>
        hasInfo &&
        css`
            padding-bottom: 24px;
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
            ::before,
            ::after {
                display: none;
            }
            @media ${respondAbove.xl} {
                padding: 35px 40px 32px;
            }
        `}

    ${({ isDisabled }) =>
        isDisabled &&
        css`
            pointer-events: none;

            input[type='radio'] {
                &::before {
                    background-color: ${({ theme }) =>
                        theme.colors.grayscale_300};
                    border-color: ${({ theme }) => theme.colors.grayscale_400};
                    box-shadow: none;
                }
            }
        `};

    ${Box} {
        a {
            color: ${({ theme }) => theme.colors.secondary_500};

            &:hover {
                color: ${({ theme }) => theme.colors.secondary_700};
            }

            &:active {
                outline-color: ${({ theme }) => theme.colors.grayscale_900};
            }
        }
    }

    &:focus-within {
        border-color: ${({ theme }) => theme.colors.primary_500};

        &:has(a:focus) {
            border-color: ${({ theme, isChecked }) =>
                isChecked ? theme.colors.primary_500 : 'transparent'};
        }
    }
`
